const o = "_root_q96xi_1", t = {
  root: o
};
export {
  t as default,
  o as root
};
//# sourceMappingURL=Pressable.module.css.js.map
